// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"0d4610b5","703":"b9175fba"}[chunkId] + ".chunk.js";
};